<template>
  <v-dialog
    v-model="shouldShowDialog"
    :persistent="isLoading"
    max-width="600"
  >
    <v-card :loading="isLoading">
      <v-card-title>
        Contact Us!
      </v-card-title>

      <v-card-text>
        <v-form
          :disabled="isLoading"
        >
          <v-text-field
            v-model.trim="form.name"
            class="mb-3"
            type="text"
            :hide-details="!$v.form.name.$anyError"
            :error-messages="$v.form.name.$anyError ? ['Please enter a valid name'] : null"
            counter="200"
            label="Name"
            outlined
            required
            dense
            @input="$v.form.name.$touch()"
            @blur="$v.form.name.$touch()"
          ></v-text-field>

          <v-text-field
            v-model.trim="form.company_name"
            class="mb-3"
            type="text"
            :hide-details="!$v.form.company_name.$anyError"
            :error-messages="$v.form.company_name.$anyError ? ['Please enter a valid company name'] : null"
            counter="200"
            label="Company Name"
            outlined
            required
            dense
            @input="$v.form.company_name.$touch()"
            @blur="$v.form.company_name.$touch()"
          ></v-text-field>

          <v-text-field
            v-model.trim="form.email"
            class="mb-3"
            type="email"
            :hide-details="!$v.form.email.$anyError"
            :error-messages="$v.form.email.$anyError ? ['Please enter valid email address'] : null"
            counter="200"
            label="Email Address"
            outlined
            required
            dense
            @input="$v.form.email.$touch()"
            @blur="$v.form.email.$touch()"
          ></v-text-field>

          <v-textarea
            v-model.trim="form.message"
            :hide-details="!$v.form.message.$anyError"
            :error-messages="$v.form.message.$anyError ? ['Please enter valid message'] : null"
            counter="1000"
            label="Message"
            outlined
            required
            dense
            @input="$v.form.message.$touch()"
            @blur="$v.form.message.$touch()"
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          text
          depressed
          class="mr-3"
          color="primary"
          @click="shouldShowDialog = false"
        >
          Cancel
        </v-btn>

        <v-btn
          text
          depressed
          color="primary"
          :loading="isLoading"
          :disabled="isLoading"
          @click="handleSubmit"
        >
          Send
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { email, required, minLength, maxLength } from "vuelidate/lib/validators"

const generateForm = () => ({
  name: "",
  email: "",
  company_name: "",
  message: ""
})

export default {
  name: "ContactForm",

  data: () => ({
    isLoading: false,
    shouldShowDialog: false,

    form: generateForm()
  }),

  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(200)
      },
      email: {
        email,
        required,
        maxLength: maxLength(200)
      },
      company_name: {
        required,
        maxLength: maxLength(200)
      },
      message: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000)
      }
    }
  },

  methods: {
    async handleSubmit() {
      await this.$v.$touch()

      if (this.$v.$anyError) {
        this.$store.dispatch("toasts/add", { text: "Please enter correct values" })

        return
      }

      // Show a loader while the request is being processed
      this.isLoading = true

      const loaderId = Symbol()
      await this.$store.dispatch("loaders/add", loaderId)

      try {
        await axios({
          url: "/api/contacts",
          method: "POST",
          data: this.form
        })

        this.shouldShowDialog = false
        this.form = generateForm()

        this.$store.dispatch("toasts/add", { text: "Message received. Thank you!" })
      } catch (error) {
        logger({ type: "Contact Form Error", error })

        // show the error message to the user
        this.$store.dispatch("toasts/add", { text: "An Error Occurred." })
      } finally {
        // remove the loader
        await this.$store.dispatch("loaders/remove", loaderId)

        // enable the button
        this.isLoading = false
      }
    }
  },

  mounted() {
    window.addEventListener("showContactForm", () => {
      this.shouldShowDialog = true
    })
  }
}
</script>
